// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2wu9C","rootSmall":"AddTileButton_rootSmall__2wZZa"};